var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueDropify',{attrs:{"src":_vm.src,"height":150,"multiple":false,"message":_vm.$tc('placeholder'),"disabled":!_vm.editable,"removeIcon":!_vm.editable},model:{value:(_vm.image),callback:function ($$v) {_vm.image=$$v},expression:"image"}})}
var staticRenderFns = []

export { render, staticRenderFns }